export type FontOverrideSource = "font" | "stylesheet";

export type ProjectFontOverride = {
  family: string;
  url: string;
  weight: string;
  style: string;
  source?: FontOverrideSource | null;
};

export function inferFontOverrideSource(
  url?: string | null
): FontOverrideSource | undefined {
  if (!url) return undefined;
  const normalizedUrl = url.toLowerCase();
  if (
    normalizedUrl.includes("fonts.googleapis.com/css") ||
    normalizedUrl.includes("/css2") ||
    normalizedUrl.includes("/css?") ||
    normalizedUrl.endsWith(".css")
  ) {
    return "stylesheet" as const;
  }
  return undefined;
}

export function normalizeProjectFontOverrideForPlayer(
  font: ProjectFontOverride
): ProjectFontOverride {
  const inferredSource = inferFontOverrideSource(font.url);
  return {
    family: font.family,
    url: font.url,
    weight: font.weight,
    style: font.style,
    ...(font.source || inferredSource
      ? { source: font.source || inferredSource }
      : {}),
  };
}

export function toProjectFontInput(
  font: ProjectFontOverride
): Omit<ProjectFontOverride, "source"> {
  return {
    family: font.family,
    url: font.url,
    weight: font.weight,
    style: font.style,
  };
}
